import { useMeContext } from '@shared/contexts/hooks/useMeContext';
import { AskVeeButton } from '@shared/features/chat-with-vee-button/AskVeeButton';
import { useAnalytics } from '@shared/hooks/useAnalytics';
import { hasChatsAccess } from '@shared/utils/permissions';
import { CHATS_ROUTE } from 'clerk_common/constants/urls/routes';
import { useLocation, useNavigate } from 'react-router-dom';

export function AskVeeHeaderButton() {
  const { hasVee, isVoomaAdmin } = useMeContext();
  const { track } = useAnalytics();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const isOnChats = pathname === CHATS_ROUTE;
  if (isOnChats || !hasChatsAccess({ hasVee, isVoomaAdmin })) return null;

  const openChats = () => {
    track('Clicked Chat with Vee', { data: { location: pathname } });
    navigate(CHATS_ROUTE);
  };

  return <AskVeeButton onPress={openChats} />;
}
